import * as v from 'valibot';
import { Metadata } from './metadata';
export var PublicationSchema;
(function (PublicationSchema) {
    PublicationSchema.Kind = v.picklist([
        'event',
        'book',
        'holocaust_document',
        'legal_document',
        'victim_testimony',
        'media_article',
        'partner',
        'development_concept'
    ]);
    PublicationSchema.Locale = v.picklist(['uk', 'en']);
    PublicationSchema.Publisher = v.object({
        id: v.number(),
        fullName: v.string()
    });
    PublicationSchema.Summary = v.object({
        id: v.number(),
        kind: PublicationSchema.Kind,
        locale: PublicationSchema.Locale,
        occurredOn: v.string(),
        title: v.string(),
        description: v.string(),
        cover: v.string(),
        createdAt: v.string(),
        updatedAt: v.string(),
        publicationVersion: v.number(),
        publisher: PublicationSchema.Publisher
    });
    PublicationSchema.Detail = v.object({
        ...PublicationSchema.Summary.entries,
        content: v.any(),
        documents: v.array(v.string())
    });
    PublicationSchema.Filters = v.object({
        kind: v.optional(PublicationSchema.Kind),
        locale: v.optional(PublicationSchema.Locale),
        missing_locale: v.optional(PublicationSchema.Locale),
        title: v.optional(v.string()),
        page: v.optional(v.number()),
        page_size: v.optional(v.number()),
        sort: v.optional(v.picklist(['created_at', '-created_at', 'occurred_on', '-occurred_on']))
    });
    PublicationSchema.ListResponse = v.object({
        publications: v.array(PublicationSchema.Summary),
        metadata: Metadata
    });
    PublicationSchema.DetailResponse = v.object({
        publication: PublicationSchema.Detail
    });
    const TranslationFields = {
        title: v.pipe(v.string(), v.nonEmpty()),
        description: v.pipe(v.string(), v.nonEmpty()),
        content: v.any(),
        cover: v.pipe(v.string(), v.url()),
        documents: v.array(v.pipe(v.string(), v.url()))
    };
    PublicationSchema.CreateInput = v.object({
        kind: PublicationSchema.Kind,
        locale: PublicationSchema.Locale,
        occurredOn: v.string(),
        ...TranslationFields
    });
    PublicationSchema.AddTranslationInput = v.object({
        locale: PublicationSchema.Locale,
        occurredOn: v.string(),
        ...TranslationFields
    });
    PublicationSchema.UpdateTranslationInput = v.object({
        occurredOn: v.string(),
        ...TranslationFields
    });
})(PublicationSchema || (PublicationSchema = {}));
